export default __webpack_public_path__ + "static/media/slideofertas-02.247f2d8f.jpg";